
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'


import { mapState, mapGetters } from 'vuex'

import { __BANNER__ } from '../../../../utils/stroage/nameSpace'
import { CACHE_INFO_KEYS, cacheObjByKey, checkCacheVersionIsRight, initStateInCacheHas } from '../../../../utils/cache'
import { sysBannerList } from '../../../../api/sysBanner/sysBanner'
import { deviceType } from '../../../../utils/device'
import isActive from '../../../../mixins/isActive'

export default {
name: 'Carousel',
components: { Swiper, SwiperItem },
mixins: [ isActive ],
data () {
return {
carousel: {
finishUpdateTime: '',
cacheInfoKey: CACHE_INFO_KEYS.SYS_BANNER,
currentIndex: 0,
items: []
}
}
},
computed: {
...mapState({
locale: state => state.i18n.locale
}),
...mapGetters(['cacheInfo'])
},
watch: {
cacheInfo () {
if (this.isActive && !checkCacheVersionIsRight({ ...this.carousel, [`value_${this.locale}`]: !0 })) {
this.initSystemBanners()
}
},
locale () {
if (this.isActive) {
this.initSystemBanners()
}
}
},
methods: {
initSystemBanners () {
return new Promise((resolve, reject) => {
const cacheCarouselCacheInfo = initStateInCacheHas(__BANNER__) || {}
if (checkCacheVersionIsRight(cacheCarouselCacheInfo)) {
this.carousel.items = cacheCarouselCacheInfo[`value_${this.locale}`].data
this.carousel.finishUpdateTime = cacheCarouselCacheInfo[`value_${this.locale}`].finishUpdateTime
} else {
this.$loading.show()
sysBannerList({
deviceType,
languageCode: this.locale
})
.then(res => {
this.$loading.hide()
if (res.success) {
const { data: carousels } = res
if (carousels) {
this.carousel.finishUpdateTime = cacheObjByKey(__BANNER__, carousels)[`value_${this.locale}`].finishUpdateTime
this.carousel.items = carousels
}
} else {
this.$message.error(res.message)
return reject(new Error(res.message))
}
})
.catch(err => {
this.$loading.hide()
this.$message.error(err.message)
return reject(err)
})
}
})
}
},
activated () {
this.initSystemBanners()
}
}



// WEBPACK FOOTER //
// ./src/views/Home/components/Carousel/Carousel.vue